import { useDispatch, useSelector } from "react-redux";
import Button from "./ui/Button";
import { useEffect } from "react";
import { incrementTime, setInicioFecha } from "../features/ui/uiSlice";
import { RootState } from "../store";
import { formatoTiempo } from "../hooks/elapsed";
import { Label } from "./ui/Label";
import { Spinner } from "./Spinner";
import { InteraccionesComponent } from "./InteraccionesComponent";
import { useForm } from "../hooks/useForm";
import { InputBaseClassName } from "./ui/Input";
import { useFinalizarLlamadaMutation } from "../services/docs";
import { toastr } from "react-redux-toastr";
import { useNavigate } from "react-router-dom";
import { Boton } from "./ui/Boton";
import { SaveAll } from "lucide-react";

const vacio = {
  fi_medio_contratacion: "",
  fi_tipo_llamada: "",
  fc_comentarios: "",
};

export const LlamadaPendienteComponent = ({
  llamada,
  tt_llamada,
  agregarInteraccion,
  isLoading,
  interacciones,
  medio_contratacion,
  tipo_llamada,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [finalizarAction, { data, isLoading: carga }] =
    useFinalizarLlamadaMutation();
  const fecha_elapsed = useSelector(
    (state: RootState) => state.ui.fecha_elapsed
  );

  const {
    formulario,
    handleInputChange,
    handleSelectChange,
    handleTexareChange,
    reset,
  } = useForm(vacio);

  useEffect(() => {
    if (llamada.length > 0) {
      dispatch(setInicioFecha(llamada[0].fd_registro));
      const interval = setInterval(() => {
        dispatch(incrementTime());
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [llamada]);

  const finalizarLlamada = async () => {
    if (formulario.fi_tipo_llamada === "") {
      toastr.error("Debe de seleccionar  Tipo de Llamada");
      return;
    }
    if (formulario.fi_medio_contratacion === "") {
      toastr.error("Debe de seleccionar un medio de contratación");
      return;
    }
    if (formulario.fc_comentarios === "") {
      toastr.error("Debe de agregar un comentario");
      return;
    }

    const ll = await finalizarAction({
      ...formulario,
      fi_tipo_llamada: +formulario.fi_tipo_llamada,
      fi_medio_contratacion: +formulario.fi_medio_contratacion,
      id: llamada[0].id,
    })
      .unwrap()
      .catch((err: any) => {
        if (err.status === 400) {
          if (err.data.message) {
            if (Array.isArray(err.data.message)) {
              err.data.message.map((m: any) => {
                toastr.error(m);
              });
            } else {
              toastr.error(err.data.message);
            }
          }
        }
        toastr.error(err.message);
        return;
      });
    if (ll.status) {
      toastr.info(ll.message);
      navigate(`/home/inbount`);
    } else {
      toastr.error(ll.message);
    }
  };

  if (!tt_llamada) {
    return (
      <div className="card mb-3 rounded-xl p-0 pb-2">
        <div className="flex w-full py-2">
          <h1 className=" mt-2 w-1/2 rounded-t-xl text-center text-primary">
            No tiene Interacción
          </h1>
          <div className="mt-2 w-1/2">
            {!isLoading && (
              <Button onClick={agregarInteraccion} className="m-auto">
                Agregar Interacción
              </Button>
            )}
            {isLoading && (
              <div className="flex w-full justify-center">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <div className="mb-5 flex items-center justify-between rounded-2xl border border-slate-100 bg-white p-8 shadow-sm">
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <span className="relative flex h-3 w-3">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-75"></span>
                <span className="relative inline-flex h-3 w-3 rounded-full bg-red-500"></span>
              </span>
              <span className="text-[11px] font-black uppercase tracking-[0.2em] text-red-600">
                Llamada Pendiente
              </span>
            </div>
            <span className="font-manrope text-6xl font-black tracking-tighter text-metric-blue-900">
              {formatoTiempo(fecha_elapsed)}
            </span>
          </div>
        </div>
        <div className=" mb-3 rounded-2xl  border border-slate-100 bg-white p-0 p-8 pb-2 shadow-sm">
          <div className="flex w-full py-2">
            <div className="mt-2 w-1/2 rounded-t-xl text-center">
              <InteraccionesComponent inter={interacciones} />
            </div>
            <div className="w-1/2 px-2">
              <div>
                <div className="flex flex-col px-6 py-2">
                  <Label
                    htmlFor="fi_tipo_llamada"
                    className="font-inter text-[11px] font-bold uppercase tracking-wider text-slate-500"
                  >
                    Tipo de Llamada:
                  </Label>
                  <select
                    className="rounded-metric w-full border border-slate-100 bg-slate-50 px-3 py-2.5 text-sm outline-none transition-all placeholder:text-slate-400 focus:border-metric-blue-400 focus:ring-2 focus:ring-metric-blue-100"
                    name="fi_tipo_llamada"
                    onChange={handleSelectChange}
                    value={formulario.fi_tipo_llamada}
                  >
                    <option value="">Selecciona un tipo de llamada</option>
                    {tipo_llamada &&
                      tipo_llamada.length > 0 &&
                      tipo_llamada.map((t: any) => {
                        return (
                          <option key={t.idTipoLlamada} value={t.idTipoLlamada}>
                            {t.descTipoLlamada}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div>
              <div>
                <div className="flex flex-col px-6 py-2">
                  <Label
                    htmlFor="fi_medio_contratacion"
                    className="font-inter text-[11px] font-bold uppercase tracking-wider text-slate-500"
                  >
                    Medio de contratación:
                  </Label>
                  <select
                    className="rounded-metric w-full border border-slate-100 bg-slate-50 px-3 py-2.5 text-sm outline-none transition-all placeholder:text-slate-400 focus:border-metric-blue-400 focus:ring-2 focus:ring-metric-blue-100"
                    name="fi_medio_contratacion"
                    onChange={handleSelectChange}
                    value={formulario.fi_medio_contratacion}
                  >
                    <option value="">
                      Selecciona un medio de contratación
                    </option>
                    {medio_contratacion &&
                      medio_contratacion.length > 0 &&
                      medio_contratacion.map((t: any) => {
                        return (
                          <option key={t.id} value={t.id}>
                            {t.fc_medio_contratacion}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div>
              <div>
                <div className="flex flex-col px-6 py-2">
                  <Label
                    htmlFor="fc_comentarios"
                    className="font-inter text-[11px] font-bold uppercase tracking-wider text-slate-500"
                  >
                    Comentario:
                  </Label>
                  <textarea
                    name="fc_comentarios"
                    value={formulario.fc_comentarios}
                    onChange={handleTexareChange}
                    rows={3}
                    cols={4}
                    className="rounded-metric w-full border border-slate-100 bg-slate-50 px-3 py-2.5 text-sm outline-none transition-all placeholder:text-slate-400 focus:border-metric-blue-400 focus:ring-2 focus:ring-metric-blue-100"
                  />
                </div>
              </div>
              <div className="mt-2 w-full px-6">
                <Boton icon={SaveAll} onClick={finalizarLlamada}>
                  Guardar Interacción
                </Boton>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
};
